(ns common.schema.entities.company.core
  (:require [common.roles :as roles]
            [common.schema.entities.company.schema :as company]
            [potpuri.core :refer [fn->>]]))

;; Verbatim copy of common.schema.entity-types's existing company entry
;; (:read-permissions-check-fn/:disable-permissions-check-fn, entity_types.cljc
;; around line 671-700) - required here, not there, to avoid a circular
;; namespace dependency (entity_types.cljc requires this registry). Keep in
;; sync if the original ever changes.
(defn- disable-permissions-check-fn
  [{:keys [tr entity role]}]
  (or (when-not (roles/user? role)
        (tr :not-allowed))
      (cond
        (->> entity
             :oppo/_target-asset
             (remove :common/disabled?)
             (seq))
        (tr :cannot-delete-asset-when-target-in-oppo)

        (->> entity
             :fof-asset/_gp
             (remove :common/disabled?)
             (seq))
        (tr :cannot-delete-when-gp-in-fund)

        (->> entity
             :holding/_target-asset
             (remove :common/disabled?)
             (seq))
        (tr :cannot-delete-asset-when-target-in-holding)

        (->> entity
             :kpi-member/_asset
             (remove :common/disabled?)
             (remove (fn->> :kpi-member/target :common/disabled?))
             (seq))
        (tr :cannot-delete-asset-when-active-in-kpi-reports))))

(def entity-type-definition
  {:entity-type                  :entity.type/company
   :schema                       company/schema
   :name                         {:en "Company"}
   :plural                       {:en "Companies"}
   :icon                         :fa-building
   :create-icon                  :fa-layer-plus
   :read-permissions-check-fn    (fn [{:keys []}] true)
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; Explicitly false: company's dedicated OpenSearch index already exists
   ;; and is populated via the legacy common.opensearch.entity-indices
   ;; mechanism, not the newer :entity/search-index?-driven
   ;; backend.search.dedicated.indexes/init! path - this key would otherwise
   ;; default to true just because :search is present below.
   :search-index? false

   :search        {:result/title-attr    :asset/name
                   :list/default-columns [:asset/name
                                          :asset/description
                                          :company/website
                                          :asset/city
                                          :company/company-owner]
                   :views                {:grid {:po-default-field-paths [[:asset/name]
                                                                          [:asset/description]
                                                                          [:company/website]
                                                                          [:asset/city]
                                                                          [:company/company-owner]]
                                                 :mandatory-field-paths  [[:asset/name]]}}}})
